import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import styles from "./style.module.scss";
import { Link } from "react-router-dom";
import { HiMenuAlt2 } from "react-icons/hi";

const Header = () => {
  return (
    <header>
      <Navbar expand="md">
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <HiMenuAlt2 />
        </Navbar.Toggle>
        <Navbar.Brand as={Link} to="/" className={styles.Moblogo}>
          <img
            src="/assets/images/logo.png"
            alt="Logo"
            className={styles.logo}
          />
        </Navbar.Brand>
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="justify-content-between"
        >
          <Nav>
            <Nav.Link as={Link} to="/">
              Home
            </Nav.Link>
            <a  href="/#about">
              About
            </a>
            <Nav.Link as={Link} to="/portfolio">
              Portfolio
            </Nav.Link>
          </Nav>
          <Navbar.Brand as={Link} to="/" className={styles.Desklogo}>
            <img
              src="/assets/images/logo.png"
              alt="Logo"
              className={styles.logo}
            />
          </Navbar.Brand>
          <Nav>
            <a href="/#skills">
              Skills
            </a>
            <Nav.Link as={Link} to="/contact">
              Contact
            </Nav.Link>
            <Nav.Link
              as={Link}
              to={"https://wa.me/00962770718344?text=Hello%20Mahmoud"}
              target="_blank"
              className={styles.buttonNav}
            >
              WhatsApp
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};

export default Header;
